import { users as usersServices } from '@coligo-org/fe-common/services';
import { STORAGE_KEYS } from '@coligo-org/fe-common/constants';
import { updateUserStart, updateUserEnd } from './updateUser';

import { ErrorsActions } from '../error';
import logger from '../../../common/services/logService';
import { refreshUserData } from '../../../auth/state/actions/auth';
import { setJwt } from '../../../auth/services/authService';

export default ({ user, callback }) =>
  async dispatch => {
    try {
      dispatch(updateUserStart());
      const password = user.get('password');
      const { data: authData } = await usersServices.updateMeV1(user);
      if (password) {
        localStorage.setItem(STORAGE_KEYS.TOKEN_KEY, authData.newJwt);
        localStorage.setItem(
          STORAGE_KEYS.REFRESH_TOKEN_KEY,
          authData.newRefreshToken,
        );
        localStorage.setItem(
          STORAGE_KEYS.REFRESH_TOKEN_ID_KEY,
          authData.newRefreshTokenId,
        );
        setJwt(authData.newJwt);
      }
      localStorage.setItem(
        STORAGE_KEYS.STRINGIFIED_USER_DATA_KEY,
        JSON.stringify(authData.user),
      );
      dispatch(refreshUserData());
      if (callback) callback();
    } catch (error) {
      logger.log(error);
      if (error.response) {
        dispatch(ErrorsActions.addError(error.response.data.message));
      }
    } finally {
      dispatch(updateUserEnd());
    }
  };
